module.exports = __webpack_public_path__ + "img/progress_095.a47df8a8.png";